/**
 * <s-theme-toggle> switches the storefront between light and dark color schemes.
 *
 * Commands (dispatched via commandfor/command on a descendant button):
 *   --toggle-theme  Flips `data-theme` on <html> and stores the choice in localStorage.
 *
 * The initial `data-theme` is set by the inline bootstrap in layout/theme.liquid
 * (stored choice, else the visitor's OS preference) so the page never flashes.
 */
const STORAGE_KEY = 'theme-color-scheme';

class ThemeToggle extends HTMLElement {
  connectedCallback() {
    this.#sync();
    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle-theme') return;
      const root = document.documentElement;
      const next = root.dataset.theme === 'dark' ? 'light' : 'dark';
      root.dataset.theme = next;
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {}
      this.#sync();
    });
  }

  #sync() {
    const isDark = document.documentElement.dataset.theme === 'dark';
    this.querySelector('button')?.setAttribute('aria-pressed', String(isDark));
  }
}

if (!customElements.get('s-theme-toggle')) {
  customElements.define('s-theme-toggle', ThemeToggle);
}
